import { RootState } from '../../rootReducer'
import { createSelector } from 'reselect'

const riskScoreFeatureFlag = (state: RootState) => !!state.featureFlags?.riskScoreEnabled
export const isRiskScoreEnabled = createSelector([riskScoreFeatureFlag], (flag): boolean => !!flag)
